import React, { useEffect, useState } from 'react'
import AllCategory1 from '../Assets/ResidentialProperties1.png'
import { Get_Api } from '../ApiUrls';
import { useNavigate } from 'react-router-dom';
import EnquiryModel from './EnquiryModel';


function ResidentialProperties({ Name, Location }) {
    const navigate = useNavigate()
    const [ResidentialProperties, setResidentialProperties] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const GetAllResidentialProperties = async () => {
        try {
            const queryParams = new URLSearchParams();

            if (Location) {
                queryParams.append("Location", Location);
            }
            if (Name) {
                queryParams.append("Name", Name);
            }
            setIsUploading(true)

            const response = await Get_Api(`api/admin/GetAllPropertiesCategorywise?Category=Residential&${queryParams.toString()}`)
            setResidentialProperties(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllResidentialProperties();
    }, []);
    useEffect(() => {
        GetAllResidentialProperties();
    }, [Name, Location]);

    const Propertydetails = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/PropertyDetails/${id}`)
    }

    const [selectedProperty, setselectedProperty] = useState(null);

    const [isOpenEnquiryModel, setisOpenEnquiryModel] = useState(false);

    const OpenEnquiryModel = (id) => {
        setselectedProperty(id)
        setisOpenEnquiryModel(true)
    }
    const CloseEnquiryModel = () => {
        setselectedProperty(null)
        setisOpenEnquiryModel(false)
    }

    return (
        <div>
            <div className="container">
                <h1 className="title">Residential Properties</h1>
                <br />
                <br />
                <div className="property-grid">
                    {ResidentialProperties?.length === 0 ? (
                        <p className="no-property-message">No Property in this category</p>
                    ) : (
                        ResidentialProperties?.map((property, index) => (
                            <>
                                <div className="property-card" key={index}>
                                    <div className="image-wrapper">
                                        <img src={property?.MainImage || AllCategory1} alt={property?.Name} className="property-image" />
                                        {!property?.featured && <span className="featured-badge">Featured</span>}
                                        <span onClick={() => { OpenEnquiryModel(property?._id) }} style={{ cursor: 'pointer' }} className="featured-badge2">Price On Request</span>
                                        {/* <div onClick={() => { Propertydetails(property?._id) }} className="overlay">View Details ↗</div> */}
                                    </div>
                                    <h2 className="property-title">{property?.Name}</h2>
                                    {/* <p className="property-price">INR. {property?.Price}</p> */}
                                    <div className="property-info">
                                        <span className="location">📍 {property?.Address}</span>
                                        {/* <span className="size">📏 {property?.PerSquarePrice}</span> */}
                                    </div>
                                    <button className="seeprop" onClick={() => { Propertydetails(property?._id) }}>See Details</button>

                                </div>
                            </>
                        ))
                    )}
                </div>
                <EnquiryModel
                    isOpen={isOpenEnquiryModel}
                    onClose={CloseEnquiryModel}
                    selectedProperty={selectedProperty}
                />
            </div>
        </div>
    )
}

export default ResidentialProperties